import { render } from "./xiaohsaccount.vue?vue&type=template&id=72ca4095&scoped=true"
import script from "./xiaohsaccount.vue?vue&type=script&lang=js"
export * from "./xiaohsaccount.vue?vue&type=script&lang=js"

import "./xiaohsaccount.vue?vue&type=style&index=0&id=72ca4095&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ca4095"]])

export default __exports__